import React from "react";
import { Box, Typography, TextField, Divider, IconButton } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import CloseIcon from "@mui/icons-material/Close";
import { cardTileSx, cardAddTileSx, cardRemoveButtonSx, cardGridSx } from "../../../theme/cardTileTokens";

const emailFieldSx = {
  "& .MuiOutlinedInput-root": {
    fontSize: "0.9375rem",
    fontWeight: 500,
    borderRadius: 1.5,
    backgroundColor: "#fff",
    "&:hover fieldset": { borderColor: "#163666" },
    "&.Mui-focused fieldset": { borderColor: "#163666", borderWidth: 2 },
  },
};

export const AdditionalEmailSection = ({
  formData,
  updateAdditionalEmail,
  addAdditionalEmail,
  removeAdditionalEmail,
  isEditable,
  t,
}) => {
  const emails = formData.additionalEmails?.length ? formData.additionalEmails : [""];

  return (
    <>
      <Box sx={{ display: "flex", alignItems: "center", gap: 1.5, mb: 1 }}>
        <Box sx={{ width: 3, height: 22, backgroundColor: "#163666", borderRadius: 2, flexShrink: 0 }} />
        <Typography variant="h6" sx={{ fontWeight: 700, color: "#1a1a2e" }}>
          {t.additionalEmailAddress}
        </Typography>
      </Box>

      <Typography variant="body2" sx={{ color: "#6b7280", mb: 2.5, ml: 2.25, lineHeight: 1.55 }}>
        {t.additionalEmailDescription}
      </Typography>

      <Box sx={{ ...cardGridSx, mb: 2 }}>
        {emails.map((email, index) => (
          <Box key={index} sx={cardTileSx}>
            {isEditable && emails.length > 1 && (
              <IconButton
                size="small"
                aria-label={t.removeEmail}
                onClick={() => removeAdditionalEmail(index)}
                sx={cardRemoveButtonSx}
              >
                <CloseIcon sx={{ fontSize: 14 }} />
              </IconButton>
            )}
            <Typography variant="caption" sx={{ color: "#9AA0A6", mb: 0.5 }}>
              {t.email} {index + 1}
            </Typography>
            <TextField
              fullWidth
              size="small"
              type="email"
              placeholder={t.enterAdditionalEmail}
              value={email}
              onChange={(e) => updateAdditionalEmail(index, e.target.value)}
              disabled={!isEditable}
              variant="outlined"
              sx={emailFieldSx}
            />
          </Box>
        ))}

        {isEditable && (
          <Box onClick={addAdditionalEmail} sx={cardAddTileSx}>
            <AddIcon />
          </Box>
        )}
      </Box>

      <Divider sx={{ mb: 4, borderColor: "#dfdfdf" }} />
    </>
  );
};
